import { namespaces, useSharedTranslation } from 'us-react-components/dist/hooks/useSharedTranslation';
import { ArticleCard } from 'us-react-components/dist/ArticleCard/ArticleCard';
import { useDependencies } from '../../dependencies';

const ARTICLES = [
  {
    imageUrl: 'https://storage.googleapis.com/assets.urbansitter.com/static/img/articles/how-babysitting-works.webp',
    linkUrl: 'https://www.urbansitter.com/how-it-works-babysitting/?utm_source=caregiver_dashboard',
    title: 'components.articles.howItWorks',
    altText: 'Sitter holding flowers'
  },
  {
    imageUrl: 'https://storage.googleapis.com/assets.urbansitter.com/static/img/articles/how-urbansitter-works-for-caregivers.webp',
    linkUrl: 'https://support.urbansitter.com/hc/en-us/articles/360050613114-How-UrbanSitter-works-for-caregivers/?utm_source=caregiver_dashboard',
    title: 'components.articles.starting',
    altText: 'Sitter playing patty cake with child'
  },
  {
    imageUrl: 'https://storage.googleapis.com/assets.urbansitter.com/static/img/articles/how-to-get-jobs.webp',
    linkUrl: 'https://blog.urbansitter.com/how-to-get-jobs-on-urbansitter/?utm_source=caregiver_dashboard',
    title: 'components.articles.howToGetJobs',
    altText: 'Sitter holding child in lap'
  },
]

const ArticlesAndResources = (): JSX.Element => {
  const { services: { tracker } } = useDependencies();
  const { t } = useSharedTranslation(namespaces.caregiver);

  const trackEvent = async (event: string, params?: {elementText: string}): Promise<void> => tracker.track(event, params);

  return (
    <div className='mb-20 hidden sm:block'>
      <span className='block font-bold mb-4'>{t('pages.sitter.dashboard.resources')}</span>
      <div className='flex flex-column gap-8'>
        {ARTICLES.map(article => (
          <div key={article.title}>
            <ArticleCard linkUrl={article.linkUrl} imageUrl={article.imageUrl} title={t(article.title)} altText={article.altText} trackingCallback={trackEvent}/>
          </div>
        ))}
      </div>
    </div>
  );
};

export { ArticlesAndResources };
